// Small helper for the review module's authenticated file downloads
// (CSV/RIS/BibTeX/SVG). These are plain GETs behind the same JWT the rest of
// the app uses, so a bare <a href> download won't carry the auth header --
// fetch as a blob instead and trigger the save via a synthetic click.
import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PROD_BACKEND + "review/" : process.env.REACT_APP_DEV_BACKEND + "review/";

export async function fetchReviewBlob(path) {
    const response = await axios.get(API_URL + path, { headers: authHeader(), responseType: "blob" });
    return response.data;
}

export async function downloadReviewFile(path, filename) {
    const blob = await fetchReviewBlob(path);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

const reviewDownload = { fetchReviewBlob, downloadReviewFile };
export default reviewDownload;
